<template>
  <div class="info-page">
    <crumbs title="用户管理" />
    <el-form
      :model="form"
      :rules="rules"
      ref="ruleForm"
      label-position="right"
      label-width="auto"
      disabled
    >
      <div class="info-page__item">
        <div class="info-page__title">
          <span>认证人信息</span>
        </div>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="认证人姓名" prop="name">
              <el-input
                v-model="form.name"
                placeholder="请填写认证人姓名"
                maxlength="15"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="联系方式" prop="linkMode">
              <el-input
                v-model="form.linkMode"
                placeholder="请填写手机或固定座机 如：010-87654321"
                maxlength="13"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="联系地址" prop="areaList">
              <region v-model="form.areaList" placeholder="请选择联系地址" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="详细地址" prop="address">
              <el-input
                v-model="form.address"
                placeholder="请填写详细地址"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="所在企业" prop="companyName">
              <el-input
                v-model="form.companyName"
                placeholder="请填写所在企业 如无企业请填写无"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="邮箱" prop="email">
              <el-input
                v-model="form.email"
                placeholder="请填写邮箱"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>

    <!-- 是否添加审核模块 -->
    <!-- 如果 certificationStatus 不等于1不允许审核 -->
    <!-- form.certificationStatus === 1 -->
    <template v-if="false">
      <el-form
        :model="aduitForm"
        :rules="aduitRules"
        ref="aduitForm"
        label-position="right"
        label-width="auto"
      >
        <div class="info-page__item">
          <div class="info-page__title">
            <span>审核</span>
          </div>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item prop="status">
                <el-radio-group v-model="aduitForm.status" size="small">
                  <el-radio :label="2" border>通过</el-radio>
                  <el-radio :label="3" border>不通过</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10" v-if="aduitForm.status === 3">
            <el-col :span="24">
              <el-form-item prop="description">
                <el-input
                  v-model="aduitForm.description"
                  type="textarea"
                  :autosize="{ minRows: 3 }"
                  placeholder="不通过，请填写不通过原因"
                  maxlength="200"
                  show-word-limit
                  resize="none"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div class="info-page__aduit fn-text-center mt-20">
        <el-button
          type="primary"
          :loading="isLoading"
          plain
          @click="handlerAduitData('aduitForm')"
          >提交审核</el-button
        >
      </div>
    </template>

    <div class="info-page__submit fn-text-center mt-20" v-if="false">
      <el-button
        type="primary"
        :loading="isLoading"
        plain
        @click="handlerModifyData('ruleForm')"
        >修改</el-button
      >
    </div>
  </div>
</template>

<script>
// 个人认证不允许修改
// 如果 certificationStatus 不等于1不允许审核
import CheckObj from "@/utils/check.js";
export default {
  name: "perCer",
  data() {
    const isEmpty = (
      message = "该项值不能为空",
      trigger = ["blur", "change"]
    ) => {
      return {
        required: true,
        message,
        trigger
      };
    };
    return {
      // 是否处于loading状态
      isLoading: false,
      //表单
      form: {
        name: "",
        linkMode: "",
        areaList: [],
        address: "",
        companyName: "",
        email: ""
      },
      rules: {
        name: [
          isEmpty("请填写认证人姓名"),
          {
            validator: (rule, value, callback) => {
              if (value && !CheckObj.checkChineseName(value)) {
                return callback(new Error("请填写正确的中文姓名"));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        linkMode: [
          isEmpty("请填写联系电话"),
          {
            validator: (rule, value, callback) => {
              if (
                value &&
                !CheckObj.checkPhone(value) &&
                !CheckObj.checkTelephone(value)
              ) {
                return callback(new Error("请填写正确的电话号码"));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        areaList: [isEmpty("请选择联系地址", "change")],
        companyName: [isEmpty("请填写所在企业")],
        email: [
          isEmpty("请填写邮箱"),
          {
            validator: (rule, value, callback) => {
              if (value && !CheckObj.checkEmail(value)) {
                return callback(new Error("请填写正确的邮箱地址"));
              }
              callback();
            },
            trigger: "blur"
          }
        ]
      },
      aduitForm: {
        status: 1,
        description: ""
      },
      aduitRules: {
        status: [
          {
            validator: (rule, value, callback) => {
              if (value === 1) {
                return callback(new Error("请选择是否通过"));
              }
              callback();
            },
            trigger: ["blur", "change"]
          }
        ],
        description: [isEmpty("请填写不通过原因")]
      }
    };
  },
  created() {
    this.loadInfo();
  },
  methods: {
    // 正向处理数据 将数据处理后提交
    processDataSubmit() {
      const {
        // list
        areaList,
        ...others
      } = this.form;
      // 省市区
      const [provinceCode = "", cityCode = "", districtCode = ""] = areaList;
      return {
        ...others,
        provinceCode,
        cityCode,
        districtCode
      };
    },
    // 逆向处理数据 获取后进行数据处理回显
    downloadProcessData(data) {
      const {
        provinceCode = "",
        cityCode = "",
        districtCode = "",
        ...others
      } = data;
      return {
        ...others,
        areaList: [provinceCode, cityCode, districtCode]
      };
    },
    downloadProcessData2(data) {
      const { certificationStatus: status, certificationReason: description } =
        data;
      return { status, description };
    },
    // 点击审核数据按钮
    handlerAduitData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadAduitData();
        }
      });
    },
    // 加载审核数据接口
    loadAduitData() {
      this.isLoading = true;
      const { id } = this.$route.query;
      this.$api("user", "aduitPerCerUser", { ...this.aduitForm, id }).then(
        (res) => {
          this.isLoading = false;
          this.$message({
            message: res.message,
            type: res.code === 0 ? "success" : "error"
          });
          if (res.code === 0) {
            this.redirectTo();
          }
        }
      );
    },
    // 点击修改数据按钮
    handlerModifyData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadModifyData();
        }
      });
    },
    // 加载修改数据接口
    loadModifyData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      const { id } = this.$route.query;
      this.$api("user", "modifyPerCerUser", { ...params, id }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载数据接口
    loadInfo() {
      const { id } = this.$route.query;
      this.$api("user", "getPerCerInfo", {
        id
      }).then((res) => {
        const { code, message } = res;
        if (code === 0) {
          this.form = this.downloadProcessData(res.dataList[0]);
          this.aduitForm = this.downloadProcessData2(res.dataList[0]);
        } else {
          this.$message.error(message);
          this.redirectTo();
        }
      });
    },
    // 返回列表页
    redirectTo() {
      // this.redirectByPath(`/admin/userManage/userContentlist`);
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped></style>
